import { StaticBaseDao } from '@/dao';
import { EngineEvent } from '@/objects/generated';
import { useUserStore } from '@/stores';

export class EventEngineDao extends StaticBaseDao {
    public static async GetEngineEvents(EventID: number): Promise<EngineEvent[]> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return [];
        }
        return this.BaseFetchArray(
            EngineEvent,
            `EventEngine/GetEngineEvents` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'GET',
        );
    }
    public static async ReloadEvent(EventID: number): Promise<boolean | null> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return null;
        }
        return this.Get(`EventEngine/ReloadEvent` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`));
    }
    public static async MoveEventToNewRankingEngine(EventID: number, engineurl: string | null): Promise<boolean | null> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return null;
        }
        return this.Get(
            `EventEngine/MoveEventToNewRankingEngine` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (engineurl == undefined ? '' : `engineurl=${engineurl}`),
        );
    }
    public static async RemoveEventFromEngine(EventID: number, engine: string | null, address: string | null): Promise<boolean | null> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return null;
        }
        return this.Delete(
            `EventEngine/RemoveEventFromEngine` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (engine == undefined ? '' : `engine=${engine}`) +
                '&' +
                (address == undefined ? '' : `address=${address}`),
        );
    }
}
